import { autoinject, transient } from 'aurelia-dependency-injection';
import { ManageDepartmentsClientService } from '../../../../../services/manage/manage-departments.service';
import { DepartmentModel, CloneDepartmentRequest, CloneDepartmentResponse } from '../../../../../models/manage/departments.models';
import { NotifyPropertyChangedBase } from '../../../../../utilities/reflection';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { BranchModel, CloneBranchRequest, CloneBranchResponse } from '../../../../../models/manage/branches.models';
import { ManageBranchesClientService } from '../../../../../services/manage/manage-branches.service';
import { I18N } from 'aurelia-i18n';
import { NotificationType, NotificationClientService } from '../../../../../services/basics/notification-client.service';
import { UserClientService } from '../../../../../services/authentication/user-client.service';
import { RoleModel, CloneRoleRequest, CloneRoleResponse } from '../../../../../models/manage/roles.models';
import { ManageRolesClientService } from '../../../../../services/manage/manage-roles.service';


@autoinject
@transient()
export class CloneRoleDialog extends NotifyPropertyChangedBase {
    public item: RoleModel | DepartmentModel | BranchModel;
    public itemName: string;
    public reload: any;
    public cloneType: "role" | "department" | "branch";
    public assignRoleValidations: boolean;
    public assignDepartmentValidations: boolean;
    public assignBranchValidations: boolean;
    public assignRoleDashboards: boolean;
    public assignDepartmentDashboards: boolean;
    public assignBranchDashboards: boolean;
    public assignRolePermissions: boolean;
    public assignDepartmentPermissions: boolean;
    public assignBranchPermissions: boolean;
    public cloneRoles: boolean;
    public cloneDepartments: boolean;

    constructor(private dialogClient: DialogClientService,
        private manageDepartmentService: ManageDepartmentsClientService,
        private manageRolesClientService: ManageRolesClientService,
        private manageBranchesService: ManageBranchesClientService,
        private notificationService: NotificationClientService,
        private userClientService: UserClientService,
        private i18N: I18N) {
        super();
    }

    cancel() {
        this.dialogClient.hide();
    }

    clone() {
        return new Promise<CloneRoleResponse | CloneDepartmentResponse | CloneBranchResponse>((resolve) => {
            //saving of role clone
            if (this.cloneType == "role") {

                const request: CloneRoleRequest = {
                    roleId: (<RoleModel>this.item).roleId,
                    roleName: this.itemName,
                    assignDashboards: this.assignRoleDashboards,
                    assignPermissions: this.assignRolePermissions,
                    assignValidations: this.assignRoleValidations
                };

                this.manageRolesClientService.cloneRole(request).then(response => {
                    this.reload();
                    this.dialogClient.hide();
                    resolve(response);
                });
            }
            //saving of department clone
            else if (this.cloneType == "department") {
                const departmentRequest: CloneDepartmentRequest = {
                    departmentId: (<DepartmentModel>this.item).departmentId,
                    departmentName: this.itemName,
                    cloneRoles: this.cloneRoles,
                    assignRoleDashboards: this.assignRoleDashboards,
                    assignRoleValidations: this.assignRoleValidations,
                    assignRolePermissions: this.assignRolePermissions,
                    assignDepartmentDashboards: this.assignDepartmentDashboards,
                    assignDepartmentPermissions: this.assignDepartmentPermissions,
                    assignDepartmentValidations: this.assignDepartmentValidations
                }

                this.manageDepartmentService.cloneDepartment(departmentRequest).then(response => {
                    this.reload();
                    this.dialogClient.hide();
                    resolve(response);
                });
            }
            //saving of branch clone
            else if (this.cloneType == "branch") {
                const branchRequest: CloneBranchRequest = {
                    branchId: (<BranchModel>this.item).branchId,
                    branchName: this.itemName,
                    cloneDepartments: this.cloneDepartments,
                    cloneRoles: this.cloneRoles,
                    assignRoleDashboards: this.assignRoleDashboards,
                    assignRoleValidations: this.assignRoleValidations,
                    assignRolePermissions: this.assignRolePermissions,
                    assignDepartmentDashboards: this.assignDepartmentDashboards,
                    assignDepartmentPermissions: this.assignDepartmentPermissions,
                    assignDepartmentValidations: this.assignDepartmentValidations,
                    assignBranchDashboards: this.assignBranchDashboards,
                    assignBranchPermissions: this.assignBranchPermissions,
                    assignBranchValidations: this.assignBranchValidations
                }

                this.manageBranchesService.clone(branchRequest).then(response => {

                    const closeDialog = () => {
                        this.reload();
                        this.notificationService.show(this.i18N.tr('successfully-cloned-text'), this.i18N.tr('successfully-cloned-branch-text'), NotificationType.Success);
                        this.dialogClient.hide();
                        resolve(response);
                    };

                    this.userClientService.reloadUser().then(() => {
                        closeDialog();
                    }).catch(() => {
                        closeDialog();
                    });
                });
            }
        });
    }

    //deselects sub checkboxes when previous checkbox is unticked
    deselectInnerCheckBoxes() {
        if (!this.cloneDepartments && this.cloneType == 'branch') {
            this.cloneRoles = false;
            this.assignRoleDashboards = false;
            this.assignDepartmentValidations = false;
            this.assignRoleValidations = false;
            this.assignDepartmentPermissions = false;
            this.assignRolePermissions = false;
            this.assignDepartmentDashboards = false;
        }

        if (!this.cloneRoles) {
            this.assignRolePermissions = false;
            this.assignRoleValidations = false;
            this.assignRoleDashboards = false;
        }
    }

    activate(model: any) {
        this.item = JSON.parse(JSON.stringify(model.item));
        this.reload = model.reload;
        this.cloneType = model.cloneType;

        if (this.cloneType == "role") {
            this.itemName = this.item["roleName"];
        }
        else if (this.cloneType == "department") {
            this.itemName = this.item["name"];
        }
        else if (this.cloneType == "branch") {
            this.itemName = this.item["name"];
        }
    }
}
